// TrainingGallery.jsx
import React, { useState, useEffect, useRef } from 'react';
import './TrainingGallery.css';

function proxy(url) {
  return 'https://wsrv.nl/?url=' + encodeURIComponent(url);
}

var SCHOOL_IMGS = [
  { id: 1, img: proxy('https://ibots.in/wp-content/uploads/2026/03/11.png'),   alt: 'School training 1' },
  { id: 2, img: proxy('https://ibots.in/wp-content/uploads/2026/03/10.png'),   alt: 'School training 2' },
  { id: 3, img: proxy('https://ibots.in/wp-content/uploads/2026/03/9.png'),    alt: 'School training 3' },
  { id: 4, img: proxy('https://ibots.in/wp-content/uploads/2026/03/8.png'),    alt: 'School training 4' },
  { id: 5, img: proxy('https://ibots.in/wp-content/uploads/2026/03/6-2.png'),  alt: 'School training 5' },
  { id: 6, img: proxy('https://ibots.in/wp-content/uploads/2026/03/5-2.png'),  alt: 'School training 6' },
  { id: 7, img: proxy('https://ibots.in/wp-content/uploads/2026/03/4-2.png'),  alt: 'School training 7' },
  { id: 8, img: proxy('https://ibots.in/wp-content/uploads/2026/03/2-2.png'),  alt: 'School training 8' },
];

var COLLEGE_IMGS = [
  { id: 1, img: proxy('https://ibots.in/wp-content/uploads/2026/03/IMG-20250920-WA0022.jpg'),              alt: 'College training 1' },
  { id: 2, img: proxy('https://ibots.in/wp-content/uploads/2026/03/IMG-20251029-WA0005.jpg'),              alt: 'College training 2' },
  { id: 3, img: proxy('https://ibots.in/wp-content/uploads/2026/03/IMG-20250920-WA0052.jpg'),              alt: 'College training 3' },
  { id: 4, img: proxy('https://ibots.in/wp-content/uploads/2026/03/IMG-20251110-WA0201.jpg'),              alt: 'College training 4' },
  { id: 5, img: proxy('https://ibots.in/wp-content/uploads/2026/03/WhatsApp-Image-2025-10-05-at-12.31.14-PM.jpg'), alt: 'College training 5' },
];

var GOVT_IMGS = [
  { id: 1, img: proxy('https://ibots.in/wp-content/uploads/2026/03/3-1.png'), alt: 'Govt program 1' },
  { id: 2, img: proxy('https://ibots.in/wp-content/uploads/2026/03/4-1.png'), alt: 'Govt program 2' },
  { id: 3, img: proxy('https://ibots.in/wp-content/uploads/2026/03/5-1.png'), alt: 'Govt program 3' },
  { id: 4, img: proxy('https://ibots.in/wp-content/uploads/2026/03/6-1.png'), alt: 'Govt program 4' },
  { id: 5, img: proxy('https://ibots.in/wp-content/uploads/2026/03/7-1.png'), alt: 'Govt program 5' },
];

var VISIBLE = 4;

function PhotoCarousel({ items, autoInterval }) {
  var maxIndex    = items.length - VISIBLE;
  var pair        = useState(0);
  var current     = pair[0];
  var setCurrent  = pair[1];
  var intervalRef = useRef(null);

  var shift      = current * 25;
  var trackStyle = { transform: 'translateX(-' + shift + '%)' };

  function startAutoSlide() {
    if (items.length <= VISIBLE) return;
    intervalRef.current = setInterval(function () {
      setCurrent(function (prev) {
        return prev >= maxIndex ? 0 : prev + 1;
      });
    }, autoInterval || 2500);
  }

  function stopAutoSlide() { clearInterval(intervalRef.current); }

  useEffect(function () {
    startAutoSlide();
    return function () { stopAutoSlide(); };
  }, []);

  function handlePrev() { if (current > 0) setCurrent(current - 1); }
  function handleNext() { if (current < maxIndex) setCurrent(current + 1); }
  function handleDot(i) { setCurrent(i <= maxIndex ? i : maxIndex); }

  function getDotClass(i) {
    return (i >= current && i < current + VISIBLE)
      ? 'tg__dot tg__dot--active'
      : 'tg__dot';
  }

  return (
    <div
      className="tg__carousel-wrap"
      onMouseEnter={stopAutoSlide}
      onMouseLeave={startAutoSlide}
    >
      <div className="tg__photo-card">
        <button
          className={current === 0 ? 'tg__arrow tg__arrow--disabled' : 'tg__arrow'}
          onClick={handlePrev}
        >←</button>

        <div className="tg__track-outer">
          <div className="tg__track" style={trackStyle}>
            {items.map(function (item) {
              return (
                <div className="tg__photo-cell" key={item.id}>
                  <img src={item.img} alt={item.alt} className="tg__photo-img" />
                </div>
              );
            })}
          </div>
        </div>

        <button
          className={current === maxIndex || items.length <= VISIBLE ? 'tg__arrow tg__arrow--disabled' : 'tg__arrow'}
          onClick={handleNext}
        >→</button>
      </div>

      {items.length > VISIBLE && (
        <div className="tg__dots-row">
          {items.map(function (item, i) {
            return (
              <button
                key={item.id}
                className={getDotClass(i)}
                onClick={function () { handleDot(i); }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

function TrainingGallery() {
  return (
    <section className="tg__section">
      <div className="tg__header">
        <p className="tg__eyebrow">TRAINING GALLERY</p>
        <h2 className="tg__title">Student Projects &amp; Training Sessions</h2>
        <p className="tg__sub">
          Showcasing student work and training sessions from schools, colleges,
          and other educational programs.
        </p>
      </div>

      <div className="tg__block">
        <div className="tg__block-label"><span>SCHOOL STUDENTS</span></div>
        <PhotoCarousel items={SCHOOL_IMGS} autoInterval={2000} />
      </div>

      <div className="tg__block">
        <div className="tg__block-label"><span>COLLEGE STUDENTS</span></div>
        <PhotoCarousel items={COLLEGE_IMGS} autoInterval={2500} />
      </div>

      <div className="tg__block">
        <div className="tg__block-label"><span>GOVT. COLLAB PROGRAM</span></div>
        <PhotoCarousel items={GOVT_IMGS} autoInterval={2500} />
      </div>
    </section>
  );
}

export default TrainingGallery;